// extracted by css-extract-rspack-plugin
export default {"base":"Footer__base--V9lMu","nav":"Footer__nav--P5P35","menu":"Footer__menu--XRtd9","copyright":"Footer__copyright--L0GXA"};